import i18n from './i18n';

export default {
	NotFoundRecipe : 'Not Found Recipe',
	NoRecipeFound : i18n.t('error.NoRecipeFound'),
	NotFoundQuiz : 'Not Found Quiz',
	NotFoundScore : 'Not Found Score',
	NotFoundProfile : 'Not Found Profile',
	SomethingErrorHappens : 'Somethins Error Happens',
	AddRecipeFailed : 'Add Recipe Failed',
	AddScoreFailed : 'Add Score Failed',
	DeleteRecipeFailed : 'Delete Recipe Failed',
	UpdateRecipeFailed : 'Update Recipe Failed',
	UpdateRecipesFailed : 'Update Recipes Failed',
	AddProfileFailed : 'Add Profile Failed',
	UpdateProfileFailed : 'Update Profile Failed',
	UploadImageFailed : 'Upload Image Failed',
	DownloadImageFailed : 'Download Image Failed'
};

